export default __webpack_public_path__ + "static/images/team-avatar.png?b8a57dc248733c0ffb9a48aea0b0b556";